export default "__VITE_ASSET__f44eaec8__"